export {
  isScreenXXs,
  isScreenXs,
  isScreen568,
  isScreen640,
  isScreenS,
  isScreenM,
  isScreenMOrientationLandscape,
  isScreenL,
} from '@creditflowresearch/uilib/styles/screen/screen';
